<arm-layout [summaryTitle]="'IP PROFILE DETAILS'">
  <div header>
    <div class="search-container">
      <client-filter (onFilter)="onFilter($event)"></client-filter>
    </div>
    <div class="action-buttons">
      <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                      (editClick)="editItem()" [disableEdit]="isUnauthorized || !selection"
                      (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !selection || (selection && selection.defaultProfile)"
                      (refreshClick)="refresh()"></arm-action-bar>

      <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="restoreToDefault()" [disabled]="isUnauthorized || !isAnySelection() || !isDefaultProfile()">
          <span>Restore To Default</span>
        </button>
        <button mat-menu-item (click)="openColumnsConfiguration()">
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div summary>
    <ip-profiles-summary [selection]="selection">
    </ip-profiles-summary>
  </div>

  <div main>

    <arm-table [displayedColumns]="displayedColumns"
               (onSelection)="onSelection($event)" [data]="items"
               [isMultipleSelection]="isMultipleSelection"
               [isClientSide]="true" [filter]="filter"></arm-table>
  </div>
</arm-layout>

